import { TableColumn } from "../../types/table-column";

export const questionsColumns: TableColumn[] = [
  {
    type: "string",
    fieldName: "ID",
    value: "id",
    width: 5,
  },
  {
    type: "string",
    fieldName: "QUESTION",
    value: "question",
    width: 22,
  },
  {
    type: "object",
    fieldName: "STAGE",
    value: "stage",
    width: 10,
  },
  {
    type: "string",
    fieldName: "WEIGHT",
    value: "weight",
    width: 6,
  },
  {
    type: "chips",
    fieldName: "LEGAL",
    value: "legals",
    width: 15,
  },
  {
    type: "arrayIconsCircle",
    fieldName: "RISK_LEVELS",
    value: "riskLevels",
    width: 8,
  },
  {
    type: "arrayIconsCircle",
    fieldName: "Roles",
    value: "roles",
    width: 8,
  },
  // {
  //   type: "date",
  //   fieldName: "CREATED_AT",
  //   value: "created_at",
  //   width: 15,
  // },
];
